module.exports = __webpack_public_path__ + "ba844993cb2f262993205250c7f4c678.svg";